import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  Stack,
  Button,
  Divider,
  Typography,
  TextField,
  alpha,
} from '@mui/material';
import { STATUS_ALL_VALUE } from '../../config/const.config';
import Iconify from '../common/iconify.component';
import Scrollbar from '../common/scrollbar.component';
import Channels from '../form-elements/channels.component';
import Status from '../form-elements/status.component';
import CouponCodeApplyOn from '../form-elements/coupon-code-apply-on.component';
import CouponCodeOffers from '../form-elements/coupon-code-offers.component';
import useResponsive from '../../hooks/responsive.hook';
import CouponCodeCategories from '../form-elements/coupon-code-categories.component';

const FilterCouponCodes = ({ values, onCancel, onSuccess, onClear }) => {
  const isDesktop = useResponsive('up', 'lg');
  const [filters, setFilters] = useState(values);

  const handleApplyFilters = () => {
    setTimeout(() => {
      onSuccess(filters);
    }, 250);
  };

  useEffect(() => {
    setFilters({ ...values });
  }, [values]);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ px: 1, py: 2, minHeight: isDesktop ? '92px' : 76 }}
      >
        <Typography variant="subtitle1" sx={{ ml: 1, textAlign: 'center' }}>
          Filters
        </Typography>
        <IconButton
          color="inherit"
          variant="contained"
          sx={{
            marginLeft: 2,
            borderRadius: '100%',
            width: 'auto',
            padding: '8px',
            bgcolor: (theme) => alpha(theme.palette.grey[400], 1),
            '&:hover': {
              bgcolor: (theme) => alpha(theme.palette.grey[400], 1),
              boxShadow: 'none',
            },
          }}
          onClick={onCancel}
        >
          <Iconify icon="mdi:menu-close" />
        </IconButton>
      </Stack>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Scrollbar
        sx={{
          height: 1,
          '& .simplebar-content': {
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form id="list-data-filters" onSubmit={(e) => e.preventDefault()}>
          <Stack sx={{ p: 2 }}>
            <CouponCodeCategories
              id="coupon_code_categories"
              name="coupon_code_categories"
              label="Categories"
              defaultValue={filters.categories?.value}
              onChange={(v) => {
                setFilters({
                  ...filters,
                  categories: { name: 'Categories', value: v },
                });
              }}
              sx={{ width: '100%', my: 1 }}
              showAllOptions
            />

            <TextField
              id="fl_search"
              name="fl_search"
              label="Search"
              variant="filled"
              value={filters.search?.value}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  search: { name: 'Search', value: e.target.value },
                });
              }}
              sx={{ width: '100%', my: 1 }}
            />

            <Channels
              id="fl_channels"
              name="fl_channels"
              label="Channels"
              defaultValue={filters.channels?.value}
              multiple
              onChange={(v) => {
                setFilters({
                  ...filters,
                  channels: { name: 'Channels', value: v },
                });
              }}
              sx={{ width: '100%', my: 1 }}
            />

            <CouponCodeApplyOn
              id="fl_apply_on"
              name="fl_apply_on"
              label="Applicable On"
              defaultValue={filters.applyOn?.value}
              multiple={false}
              onChange={(v) => {
                setFilters({
                  ...filters,
                  applyOn: { name: 'Applicable On', value: v },
                });
              }}
              sx={{ width: '100%', my: 1 }}
            />

            <CouponCodeOffers
              id="fl_offer"
              name="fl_offer"
              label="Offer"
              defaultValue={filters.offer?.value}
              multiple={false}
              onChange={(v) => {
                setFilters({
                  ...filters,
                  offer: { name: 'Offer', value: v },
                });
              }}
              sx={{ width: '100%', my: 1 }}
            />

            <Status
              id="fl_status"
              name="fl_status"
              label="Status"
              defaultValue={
                filters.status?.value === null || filters.status?.value === ''
                  ? STATUS_ALL_VALUE
                  : filters.status?.value
              }
              multiple={false}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  status: {
                    name: 'Status',
                    value:
                      e.target.value === STATUS_ALL_VALUE
                        ? null
                        : e.target.value,
                  },
                });
              }}
              validOptions={[0, 1]}
              sx={{ width: '100%', my: 1 }}
              allOption
            />
          </Stack>
        </form>
      </Scrollbar>

      <Divider />

      <Stack spacing={1} sx={{ p: 2 }}>
        <Button
          fullWidth
          form="list-data-filters"
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
        <Button
          fullWidth
          type="button"
          color="secondary"
          variant="contained"
          startIcon={<Iconify icon="ic:round-clear-all" />}
          onClick={onClear}
        >
          Clear All
        </Button>
      </Stack>
    </>
  );
};

FilterCouponCodes.propTypes = {
  values: PropTypes.shape().isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default FilterCouponCodes;
